import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import jstz    from 'jstimezonedetect';
import Cookies from 'js-cookie';

import Icon                  from '../../../icons';
import ManageNotifications   from "./manageNotifications";
import Details               from "./details";
import { getNotificationSettings } from '../actions/action';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

// Helpers
const normalizeTimezone = (tz) => tz === "Asia/Calcutta" ? "Asia/Kolkata" : tz;
const getSiteUrl = () => document.getElementById('siteUrl')?.value ?? '';

// Sub-components
const TabNav = ({ activeTab, isAuditUser, onDetailsClick, onNotificationsClick }) => (
    <div className="detailList colFlex">
        <ul>
            <li>
                <button
                type='button'
                className={`btn-cc btn-cc__link ${activeTab === 0 ? "active" : ""}`}
                data-test="details"
                onClick={onDetailsClick}
            >
                <Icon name="UserDetail" className="icon mr__12" /> Details
            </button>
            </li>

            <li className="mt__1">
                {!isAuditUser && (
                <button
                    type='button'
                    className={`btn-cc btn-cc__link ${activeTab === 1 ? "active" : ""}`}
                    data-test="notifications"
                    onClick={onNotificationsClick}
                >
                    <Icon name="notification" className="icon mr__12" />
                    Notifications Settings
                </button>
            )}
            </li>
        </ul>
    </div>
);

const ManageProfile = ({ onClose }) => {
    const dispatch = useDispatch();

    const manageProfile = useSelector(state => state.header.manageProfile);
    
    const [supervisorInfo, setSupervisorInfo] = useState();

    useEffect(() => {
        if(manageProfile.userInfo) {
            setSupervisorInfo(manageProfile.userInfo);
        }
    }, [manageProfile.userInfo])
    

    const sessionContext = useSelector(selectSessionContextOidc);
    const {loading, userView, organizationView, tzData } = sessionContext;
    const isAuditUser    = userView?.isAuditUser ?? false;

    const [activeTab,        setActiveTab]        = useState(0);
    const [showToastMessage, setShowToastMessage] = useState(false);

    const checkTimezone = (isCloseBtnClick = false) => {
        const sysTimezone = normalizeTimezone(jstz.determine().name());
        if (userView?.TimeZoneTz !== sysTimezone && showToastMessage && isCloseBtnClick) {
            Cookies.set('Show_Is_Toast_Displayed', 'false', { domain: getSiteUrl() });
        }
    };

    // Handlers
    const handleDetailsTab = () => {
        setActiveTab(0);
    };

    const handleNotificationsTab = () => {
        setActiveTab(1);
        if (!manageProfile.notificationSettings || Object.keys(manageProfile.notificationSettings).length === 0) {
            dispatch(getNotificationSettings());
        }
    };

    // Tab render
    const renderTab = () => {
        if (activeTab === 0) {
            return (
                <Details
                    userView={userView}
                    showToastMessage={() => setShowToastMessage(true)}
                    timezoneData={tzData}
                    orgData={organizationView}
                    isLoading={loading}
                    supervisorInfo={supervisorInfo}
                />
            );
        }
        if (activeTab === 1) {
            return (
                <ManageNotifications
                    data={manageProfile.notificationSettings}
                    error={manageProfile.notificationSettingsError}
                    uView={userView}
                    isLoading={loading}
                />
            );
        }
        return null;
    };

    return (
        <div className="manageProfile">
            <div className="modalBody">
                <div className="header modalHeaderFixed">
                    <div className="headerMain rowSpaceBetween">
                        <div className="alignMiddle">
                            <button
                                type="button"
                                className="btn-cc btn-cc__link modalHeaderccLogo"
                                onClick={() => { checkTimezone(); window.location.href = '/workkards'; }}
                            >
                                <span><Icon name="CasheLogo" className="" /></span>
                            </button>
                            <h2 className="ml alignMiddle flexGrow">Profile</h2>
                        </div>
                        <div className="alignMiddle">
                            <ul className="ml">
                                <li>
                                    <button
                                        type="button"
                                        className="btn-cc btn-cc__link"
                                        onClick={() => { if (manageProfile.updatingData == null) onClose(); }}
                                    >
                                        <Icon name="close" className="icon iconSmall mr" /> Close
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="profileContainer rowFlex">
                    <TabNav
                        activeTab={activeTab}
                        isAuditUser={isAuditUser}
                        onDetailsClick={handleDetailsTab}
                        onNotificationsClick={handleNotificationsTab}
                    />

                    <div className="companyList">
                        {renderTab()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ManageProfile;